import{jsx as _jsx,Fragment as _Fragment}from"react/jsx-runtime";/**
 * FieldSet that appears flat in the form.
 *
 * @param fsProps The props for the FieldSet.
 * @returns The FieldSet.
 */export const FlatFieldSet=fsProps=>{// Despite what the linter says, we need to use a fragment here.
// eslint-disable-next-line react/jsx-no-useless-fragment
return /*#__PURE__*/_jsx(_Fragment,{children:fsProps.children})};